module.exports = __webpack_public_path__ + "image_svg.svg?7b0d60351f903c0066853adabbc638ec";


//////////////////
// WEBPACK FOOTER
// ./Content/img/image_svg.svg
// module id = 209
// module chunks = 1